<template>
    <div class="modal fade" id="create-quicknote-form" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title fw-bold" id="createQuickNotelLabel">Add quick note</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="mb-3">
                        <label for="note" class="form-label" aria-label="Note" aria-placeholder="Note">Note</label>
                        <textarea v-model="note" id="note" rows="4" cols="50" class="form-control"></textarea>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click.prevent="submitQuickNoteForm">Create</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="delete-contacts-form" tabindex="-1" aria-labelledby="createprojectlLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title fw-bold" id="createprojectlLabel">Επιβεβαίωση διαγραφής λιστών</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <p>Είστε σίγουροι ότι θέλετε να διαγράψετε τις επιλεγμένες λίστες;</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Άκυρο</button>
                    <button type="button" class="btn btn-secondary" @click="handleArchiveContacts">Διαγραφή</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="edit-form" tabindex="-1" aria-labelledby="createprojectlLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title fw-bold" id="createprojectlLabel">Επεξεργασία</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="mb-3">
                        <label for="title" class="form-label" aria-label="Title" aria-placeholder="Title">Title</label>
                        <input v-model="selectedRow.title" id="title" class="form-control" />
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Άκυρο</button>
                    <button type="button" class="btn btn-secondary" @click="updateList">Αποθήκευση</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="show-notes" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title fw-bold" id="createQuickNotelLabel">Notes</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="mb-3">
                        <div class="table-responsive">
                            <table v-if="notes && notes.length" class="table table-hover align-middle mb-0 mis_table">
                                <thead>
                                    <tr>

                                        <th style="width:45%">
                                            Note
                                        </th>
                                        <th>
                                            Created By
                                        </th>
                                        <th>
                                            Created Date
                                        </th>
                                        <th style="width:8%">
                                            Actions
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(row, index) in notes" :key="index">
                                        <td>{{ row.note }}</td>
                                        <td>{{ row.user?.username }}</td>
                                        <td>{{ row.created_at }}</td>
                                        <td><button v-if="ownNote(row) || superUser" class="btn btn-dark ms-3" @click="deleteNoteRow(row.id)" style="color: var(--secondary-color); font-weight: bold;"><i class="wx-ic wx-ic-trash" title="Archive"></i></button></td>
                                    </tr>
                                </tbody>
                            </table>
                            <div v-else>
                                <p>No notes found.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                        aria-label="Close">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div class="table-container">
        <!-- Column Selection Dropdown -->
        <div class="d-flex justify-content-end mb-2">
            <!-- <div class="col-md-4"> -->
            <!-- <label class="mb-1">Selected Columns:</label> -->
            <!-- <select v-model="selectedColumns" multiple style="min-height:200px">
            <option v-for="col in columns" :key="col.value" :value="col.value">
              {{ col.label }}
            </option>
          </select> -->
            <!-- <Select2 v-model="selectedColumns" :options="columns.map(col => ({ id: col.value, text: col.label }))"
            :settings="select2Settings" :multiple="true" class="form-control" /> -->
            <!-- </div> -->
            <div v-if="canArchive || superUser" class="dropdown " @click="toggleDropdown" @blur="closeDropdown" tabindex="0">
                <button class="ms-2 me-2 mt-2 ms-sm-3 btn btn-primary dropdown-menu-toggler" type="button"
                    style="color:var(--secondary-color); font-weight:bold">
                    <i class="wx-ic wx-ic-trash" title="Archive"></i>
                </button>
                <ul class="dropdown-menu border-0 shadow p-3 " :class="{ 'show': isDropdownOpen }"
                    :style="dropdownStyle">
                    <li><a class="dropdown-item py-2 rounded archiveSelected" href="#"
                            @click.prevent="showConfirmationModal">Αρχειοθέτηση
                            επιλεγμένων</a></li>
                </ul>
            </div>
        </div>
    </div>

    <!-- Table -->
    <div class="table-responsive">
        <table class="table table-hover align-middle mb-0 mis_table wx-lists-table">
            <thead>
                <tr>
                    <th v-if="canArchive || superUser" >
                        <div>
                            <input type="checkbox" id="checkAllToggle" @click="toggleSelectAll" />
                        </div>

                    </th>
                    <th v-for="col in filteredColumns" :key="col">
                        <div>
                            {{ getLabel(col) }}
                            <i class="fa fa-sort sorting-icon" @click.prevent="handleSortBy(col)"></i>
                        </div>
                    </th>
                    <th style="width:11%; text-align: center; align-items: center;">
                        <div>
                            Notes
                        </div>

                    </th>
                    <th style="width:15%">
                        <div>
                            Actions
                        </div>

                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, index) in data" :key="index">
                    <td v-if="canArchive || superUser" ><input type="checkbox" :value="row.id" v-model="selectedIds" /></td>
                    <td v-for="col in filteredColumns" :key="col" class="fixed-td">
    <template v-if="isLinkColumn(col)">
        <div class="d-flex justify-content-evenly align-items-center w-100">
            <!-- Editable Input (if row is being edited) -->
            <input
                v-if="editingRow && editingRow.id === row.id"
                v-model="editingRow[col]"
                class="form-control" style="min-width: 30%; max-width: 50%; text-align: center;"
            />

            <!-- Normal Text (if not editing) -->
            <router-link
                v-else
                :to="{ path: tableOptions.singlePagePath, query: { id: row.id } }"
                class="text-truncate link-fixed"
            >
                {{ row[col] }}
            </router-link>

            <!-- Edit/Save Button -->
            <button
                type="button"
                class="btn btn-secondary ms-2"
                @click="toggleEdit(row)"
                style="color: var(--secondary-color); font-weight: bold"  v-if="editingRow && editingRow.id === row.id"
            >
                <i class="wx-ic wx-ic-check" title="Save"></i>
             
            </button>
            <button
                v-else-if="canEditList(row)"
                type="button"
                class="btn btn-dark ms-2"
                @click="toggleEdit(row)"
                style="color: var(--secondary-color); font-weight: bold"

            >
               
                <i class="wx-ic wx-ic-edit" title="Edit"></i>
            </button>
        </div>
    </template>
    
    <template v-else>
        <span @click="handleClick(col, row)" class="text-truncate">
            {{ row[col] }}
        </span>
    </template>
</td>

                    <td>
                        <button type="button" class="btn wx-icon-btn" @click="showNotes(row)">
                            <i class="wx-ic wx-ic-note"></i> Show notes
                        </button>
                    </td>
                    <td>
                        <button type="button" class="btn wx-icon-btn" @click="openQuickNoteForm(row)">
                            <i class="wx-ic wx-ic-plus"></i> Add quick note
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <nav aria-label="Page navigation" v-if="data && data.length">
        <ul class="pagination mt-4" v-if="paginationLinks && paginationLinks.length > 0">
            <li class="page-item" v-for="(paginationLink, index) in paginationLinks" :key="index"
                :class="{ active: paginationLink.active }">
                <router-link
                    :to="{ path: tableOptions.path, query: { ...filters, page: getPageFromUrl(paginationLink.url) } }"
                    v-if="paginationLink.url">
                    <span class="page-link" v-html="paginationLink.label"></span>
                </router-link>
                <span class="page-link" v-else v-html="paginationLink.label"></span>
            </li>
        </ul>
    </nav>
</template>

<script>
import { ref, computed, watch } from "vue";
import { create, deleteNote } from "@/services/quicknote-list";
import { deleteList, update } from "@/services/lists";
import Select2 from "vue3-select2-component";
import { useToast } from "vue-toastification";
import { mapGetters } from "vuex";

export default {
    components: {
        Select2,
    },
    methods: {
        canEditList(list) {
            return this.userPermissions?.edit === 1 && localStorage.getItem('current_user_id') == list.createdBy;
        }
    },
    computed: {
        ...mapGetters({
            getUserPermission: 'getUserPermission',
            getSuperUserPermission: 'getSuperUserPermission', // Add this line

        }),
        superUser() {
            return this.getSuperUserPermission === 1;
        },
        userPermissions() {
            return this.getUserPermission('Lists');
        },
        canEditAllLists() {
            return this.userPermissions?.editAll === 1;
        },
        canCreateList() {
            return this.userPermissions?.create === 1;
        },
        canArchive() {
            return this.userPermissions?.archive === 1;
        },
    },
    props: {
        columns: Array, // Example: [{ value: "name", label: "Name", isLink: true, linkField: "profileUrl" }]
        data: Array, // Example: [{ name: "John", profileUrl: "/profile/john" }]
        customHandler: Function, // Function to handle clicks
        tableOptions: Object,
        archiveLists: Function,
        paginationLinks: Array,
        sortBy: Function,
        isLinkColumn: Function,
        refreshTable: Function,
    },
    data() {
        return {
            select2Settings: { multiple: true },
        };
    },
    setup(props, { emit }) {
        const selectedColumns = ref(props.columns.map(col => col.value));
        const selectedIds = ref([]);
        const isDropdownOpen = ref(false);
        const selectedContact = ref(null);
        const note = ref('');
        const notes = ref([]);
        const selectedRow = ref({id: null, title: ""});

        const editingRow = ref(null);

    const toggleEdit = (row) => {
        if (editingRow.value && editingRow.value.id === row.id) {
            updateList(row); // Pass the row to update it correctly
            editingRow.value = null; // Exit edit mode
        } else {
            editingRow.value = { ...row }; // Clone row for editing
        }
    };

    const updateList = async (row) => {
        if (!editingRow.value) return;
        
        try {
            const r = await update(row.id, { title: editingRow.value.title });
            if (r.data.success) {
                useToast().success(r.data.message);
                props.refreshTable(); // Refresh data after updating
            } else {
                useToast().error(r.data.message);
            }
        } catch (error) {
            console.error("Update failed:", error);
            useToast().error("Update failed.");
        }
    };



        const dropdownStyle = computed(() => ({
            top: isDropdownOpen.value ? '100%' : 'initial',
            right: isDropdownOpen.value ? '0' : 'initial'
        }));

        const toggleDropdown = () => {
            isDropdownOpen.value = !isDropdownOpen.value;
        };

        const closeDropdown = () => {
            isDropdownOpen.value = false;
        };

        watch(selectedColumns, (newVal) => {
            localStorage.setItem("selectedColumns", JSON.stringify(newVal));
        });

        const storedColumns = localStorage.getItem("selectedColumnsContacts");
        if (storedColumns) {
            selectedColumns.value = JSON.parse(storedColumns);
        }

        const filteredColumns = computed(() => selectedColumns.value);

        const getLabel = (value) => {
            const column = props.columns.find(col => col.value === value);
            return column ? column.label : value;
        };

        const isLinkColumn = (value) => {
            return props.isLinkColumn(value);
        };

        const getLinkField = (value) => {
            const column = props.columns.find(col => col.value === value);
            return column?.linkField || value;
        };

        // Handle Click Events
        const handleClick = (column, row) => {
            if (props.customHandler) {
                props.customHandler(column, row);
            } else {
                emit("row-clicked", { column, row });
            }
        };

        const showConfirmationModal = () => {
            $("#delete-contacts-form").modal('show');
        };

        const handleArchiveContacts = async () => {
            const response = await deleteList(selectedIds.value);
            if (response.data.success) {
                props.refreshTable();
                useToast().success(response.data.message);
                note.value = '';
                $("#delete-contacts-form").modal('hide');
            } else {
                useToast().error(response.data.message);
            }
        }

        const getPageFromUrl = (url) => {
            if (!url) return null;
            const urlObj = new URL(url, window.location.origin);
            return urlObj.searchParams.get('page');
        };

        // Handle Sort By
        const handleSortBy = (column) => {
            props.sortBy(column);
        };

        const openQuickNoteForm = (row) => {
            selectedContact.value = row;
            $("#create-quicknote-form").modal('show');
        };

        const submitQuickNoteForm = async () => {
            const response = await create(selectedContact.value.id, { note: note.value });
            if (response.data.success) {
                props.refreshTable();
                useToast().success(response.data.message);
                note.value = '';
                $("#create-quicknote-form").modal('hide');
            } else {
                useToast().error(response.data.message);
            }
        };

        const showNotes = (row) => {
            notes.value = row.notes;
            $("#show-notes").modal('show');
        };

        const toggleSelectAll = () => {
            if (!$("#checkAllToggle").is(":checked")) {
                selectedIds.value = [];
            } else {
                let ids = [];
                if (props.data && props.data.length) {
                    props.data.forEach(function (d) {
                        ids.push(d.id);
                    });
                }
                selectedIds.value = ids;
            }
        };

        const deleteNoteRow = async (id) => {
          const r = await deleteNote(id);
          if (r.data.success) {
            useToast().success(r.data.message);
          } else {
            useToast().error(r.data.message);
          }
        };

        const ownNote = (note) => {
            return note.user.id == localStorage.getItem('current_user_id');
        };

        const edit = (row) => {
            selectedRow.value = row;
            $("#edit-form").modal('show');
        };

    

        return { updateList, selectedRow, toggleEdit, editingRow, edit, ownNote, deleteNoteRow, showConfirmationModal, notes, note, showNotes, submitQuickNoteForm, openQuickNoteForm, handleArchiveContacts, toggleSelectAll, dropdownStyle, closeDropdown, toggleDropdown, isDropdownOpen, handleSortBy, selectedIds, selectedColumns, filteredColumns, getLabel, isLinkColumn, getLinkField, handleClick, getPageFromUrl };
    },
};
</script>

<style scoped>
.table-container {
    margin-top: 0;
}

.column-selection {
    margin-bottom: 10px;
}

table {
    width: 100%;
    border-collapse: collapse;
}

th,
td {
    border: 1px solid #ddd;
    padding: 8px;
}

th {
    background-color: #f4f4f4;
}

.link {
    color: blue;
    text-decoration: underline;
    cursor: pointer;
}

.clickable {
    cursor: pointer;
    color: #007bff;
}

.clickable:hover {
    text-decoration: underline;
}
.fixed-td {
    min-width: 150px; /* Set a minimum width */
    max-width: 200px; /* Set a maximum width */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.input-fixed {
    width: 80%;
    height: 100%;
    padding: 5px;
    border: none;
    text-overflow: ellipsis;
}

.link-fixed {
    display: inline-block;
    max-width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.text-truncate {
    display: inline-block;
    max-width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

</style>